import * as t from 'io-ts';
import { WeightUnitDynamicType } from 'acscp/api/models/customTypes/weightUnit';
import { LengthUnitDynamicType } from 'acscp/api/models/customTypes/lengthUnit';
import { VolumeUnitDynamicType } from 'acscp/api/models/customTypes/volumeUnit';

export const AircraftCargoInformationDynamicType = t.interface({
    maximumPayload: t.union([t.number, t.null]),
    maximumPayloadUnit: t.union([WeightUnitDynamicType, t.null]),
    cargoHold: t.union([t.string, t.null]),
    cargoHoldUnit: t.union([LengthUnitDynamicType, t.null]),
    holdVolume: t.union([t.number, t.null]),
    holdVolumeUnit: t.union([VolumeUnitDynamicType, t.null]),
    noseDoor: t.union([t.string, t.null]),
    noseDoorUnit: t.union([LengthUnitDynamicType, t.null]),
    sideDoor: t.union([t.string, t.null]),
    sideDoorUnit: t.union([LengthUnitDynamicType, t.null]),
    rearDoor: t.union([t.string, t.null]),
    rearDoorUnit: t.union([LengthUnitDynamicType, t.null]),
    upperDeckPalletPositions: t.union([t.string, t.null]),
    lowerDeckPalletPositions: t.union([t.string, t.null]),
});

export type AircraftCargoInformation = t.TypeOf<typeof AircraftCargoInformationDynamicType>;
